import React from 'react'
import { SvgIconProps } from './Home'

const FlagIcon = ({ fill, width, height }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? "24"}
    height={height ?? "24"}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill={fill ?? "#353535"}
      stroke={fill ?? "#353535"}
      strokeMiterlimit="10"
      d="M19.233 3.053c-1.264.58-2.635.91-4.032.978a13.262 13.262 0 01-3.074-.494c-1.084-.31-2.2-.487-3.328-.533a10.992 10.992 0 00-3.734.767v-.256A.522.522 0 004.535 3 .526.526 0 004 3.515v16.97c0 .284.24.515.534.515.295 0 .531-.231.531-.515v-5.399a7.065 7.065 0 013.734-.77 8.44 8.44 0 013.03.483 9.459 9.459 0 003.372.543c3.328 0 4.523-1.027 4.64-1.183A.5.5 0 0020 13.8V3.515A.522.522 0 0019.47 3a.544.544 0 00-.237.053zm-.298 10.491a7.14 7.14 0 01-3.734.771 8.44 8.44 0 01-3.03-.483 9.459 9.459 0 00-3.372-.544 9.36 9.36 0 00-3.734.63V4.872A10.52 10.52 0 018.8 4.03c1.043.046 2.071.216 3.074.504 1.084.306 2.2.48 3.328.526a11.156 11.156 0 003.734-.76v9.243z"
    ></path>
  </svg>
)

export default FlagIcon
